




















import { Component, Mixins } from "vue-property-decorator";
import { LinkMixin } from "@/mixins/LinkMixin";
import { AuthModule } from "@/store/auth.module";

@Component
export default class AppFooter extends Mixins(LinkMixin) {
  get text() {
    const text = this.$t("app-footer.text") as string;
    if (!this.$vuetify.breakpoint.smAndUp) {
      return text.replace(".", ". <br />");
    }
    return text;
  }
  get user() {
    return AuthModule.user as IUser;
  }
}
